export default "__VITE_ASSET__CTM0lPm$__"